import {Controller, useFieldArray, useFormContext} from "react-hook-form";
import {Button, Input, Select, Space} from "antd";
import {FormFieldError} from "../../../../../../design-system/form-field";
import {ProfileFormValues} from "../../schema-validation";
import {CloseOutlined, PlusCircleFilled} from "@ant-design/icons";
import {PROFILE_SOCIAL_MEDIA_OPTIONS} from "../../../../../../utils/profile";

export function ProfileSocialLinksFormField() {
  const {control, watch, formState, trigger} = useFormContext<ProfileFormValues>();
  const {fields, append, remove} = useFieldArray({
    control,
    name: "socialLinks",
  });

  const watchLinks = watch("socialLinks");

  const selectedPlatforms = watchLinks.map((link) => link.name).filter(Boolean);

  const handleAppend = () => {
    const nextAvailable = PROFILE_SOCIAL_MEDIA_OPTIONS.find(
      (option) => !selectedPlatforms.includes(option)
    );
    if (nextAvailable) {
      append({name: nextAvailable, link: ""});
      trigger("socialLinks");
    }
  };
  return (
    <div>
      <Space size={8} direction="vertical" style={{display: "flex"}}>
        <p>Social media links or websites</p>
        {fields.slice(0, 12).map((item, index) => (
          <div key={item.id} style={{display: "flex", gap: "1.6rem"}}>
            {/* // <Space size={16} key={item.id}> */}
            <div style={{flex: "1"}}>
              <Controller
                control={control}
                name={`socialLinks.${index}.link`}
                render={({
                  field: {onChange, value, ref, onBlur},
                  fieldState: {error},
                }) => (
                  <Space size={8} direction="vertical" style={{display: "flex"}}>
                    <Input
                      // id={id}
                      status={error?.message ? "error" : ""}
                      onChange={onChange}
                      onBlur={onBlur}
                      size="large"
                      value={value === null ? undefined : value}
                      placeholder="Enter a valid link"
                      ref={ref}
                      addonBefore={
                        <Controller
                          control={control}
                          name={`socialLinks.${index}.name`}
                          render={({
                            field: {onChange, value, ref},
                            fieldState: {error},
                          }) => (
                            <>
                              <Select
                                onChange={onChange}
                                value={value}
                                ref={ref}
                                size="large"
                                status={error?.message ? "error" : ""}
                                showSearch={false}
                                notFoundContent={null}
                                placeholder={""}
                                options={PROFILE_SOCIAL_MEDIA_OPTIONS.map((opt) => {
                                  const isSelected = selectedPlatforms.includes(opt);
                                  const isCurrent = opt === value;
                                  return {
                                    value: opt,
                                    label: opt,
                                    disabled: isSelected && !isCurrent,
                                  };
                                })}
                              />
                              <FormFieldError errorMessage={error?.message} />
                            </>
                          )}
                        />
                      }
                    />
                    <FormFieldError errorMessage={error?.message} />
                  </Space>
                )}
              />
            </div>

            <Button
              onClick={() => remove(index)}
              type="link"
              shape="circle"
              icon={<CloseOutlined />}
              size="small"
            />
            {/* </Space> */}
          </div>
        ))}

        {selectedPlatforms.length <= PROFILE_SOCIAL_MEDIA_OPTIONS.length && (
          <Button
            size="small"
            disabled={selectedPlatforms.length >= PROFILE_SOCIAL_MEDIA_OPTIONS.length}
            icon={<PlusCircleFilled />}
            onClick={handleAppend}
          >
            Add social media
          </Button>
        )}
        {Array.isArray(formState.errors.socialLinks) === false &&
          formState.errors.socialLinks?.message && (
            <FormFieldError errorMessage={formState.errors.socialLinks?.message} />
          )}
      </Space>
    </div>
  );
}
